import { createSlice, EntityState } from '@reduxjs/toolkit'
import { injectedOmsApi } from '@/services/oms'
import { storeAdapter } from './schema'

type Nullable<T> = T | null

type PlainInfo = {
  status: RequestState
  error?: Nullable<string>
  data: EntityState<Oms.Store, string>
}

type RequestState = 'pending' | 'fulfilled' | 'rejected' | 'none'

const initialState: PlainInfo = {
  status: 'none',
  data: storeAdapter.getInitialState(),
  error: null,
}

export const storesSlice = createSlice({
  name: '@stores',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(
        injectedOmsApi.endpoints.getAllStores.matchFulfilled,
        (state, action) => {
          state.status = 'fulfilled'
          if (action.payload.payload.stores) {
            state.data = storeAdapter.addMany(
              state.data,
              action.payload.payload.stores
            )
          }
        }
      )
      .addMatcher(
        injectedOmsApi.endpoints.getPickupStores.matchFulfilled,
        (state, action) => {
          state.status = 'fulfilled'
          const {
            id,
            earliestCollectionDate,
            earliestCollectionEndTime,
            earliestCollectionTime,
            earliestCollectionTimeStamp,
          } = action.payload.payload.stores[0] as Oms.Store
          storeAdapter.updateOne(state.data, {
            id,
            changes: {
              earliestCollectionDate,
              earliestCollectionEndTime,
              earliestCollectionTime,
              earliestCollectionTimeStamp,
            },
          })
        }
      )
  },
})
